
import flatpickr from "flatpickr";
import { getDaysBetweenDates, isMobileRes, dateToString, formatPrice, formatPriceWithDecimals, isMobileDevice, stringToDate } from "../utils/Utils";
import Billboards from "../libs/API/Billboards";
import moment from "moment";

class BillboardCalendarClass{
    constructor(){
        this.main = document.getElementById('billboard_calendar');

        this._wrapper = this.main.querySelector('.wrapper');
        this._footer = this._wrapper.querySelector('.billboard-calendar__footer');

        this._headerTitle = this.main.querySelector('.header_title');
        this._headerDateRange = this.main.querySelector('.header_date_range');
        this._graphReferences = this.main.querySelector('.graph-references');

        this._recurrencesDays = this.main.querySelector('.recurrences-days');
        this._recurrencesDaysList = this._recurrencesDays.querySelector('.list-of-days');
        this._daysSelected = [];

        this._closeBtn = this.main.querySelectorAll('.close_btn');
        this._applyModifyPeriod = this.main.querySelector('.btn-modify-period');
        
        this._dates = null;
        this._flatpickr = null;
        this._holderFlatpickr = this.main.querySelector('.holder_flatpickr');

        this._singleMonth = null;
        this._currentDateRange = null;
        this._monthsCount = 0;
        this._modifyPeriod = false;
        this._rangeDuration = 0;
        
        this._isMobileRes = isMobileRes();
        this._isOpen = false;
        
        for (const day of this._recurrencesDaysList.querySelectorAll('li')) {
            day.addEventListener('click', this._onClickDaysOfWeek.bind(this));
        };
        for (const close of this._closeBtn) {
            close.addEventListener('click', this._onClickCloseBtn.bind(this));
        };
        this._applyModifyPeriod.addEventListener('click', this._onClickApplyModify.bind(this));
        window.addEventListener('resize', this._onWindowResize.bind(this));
        this._wrapper.addEventListener('click', e => e.stopPropagation());
        this.main.addEventListener('click', this.hide.bind(this));
        
    }

    get getRangeDuration(){
        return this._rangeDuration;
    }

    set setRangeDuration(value){
        this._rangeDuration = value;
    }

    set setModifyPeriod (value){
        if(value) this._modifyPeriod = value;
    }

    get getModifyPeriod (){
        return this._modifyPeriod;
    }

    show(dateRange = null) {
        this._isOpen = true;
        document.body.classList.add('billboard-calendar--open');
        this.main.classList.add('skeleton--show');

        this._monthsCount = dateRange == null || (dateRange && dateRange.to == null) ? 2 : (dateRange.to.getFullYear()*12 + dateRange.to.getMonth()) - (dateRange.from.getFullYear()*12 + dateRange.from.getMonth()) + 1;

        if (!this._isMobileRes) {
            if(this._monthsCount <= 1){
                this.main.classList.add('billboard-calendar--single-month');
            }else{
                this.main.classList.remove('billboard-calendar--single-month');
            }
        } else {
            this.main.classList.add('billboard-calendar--single-month');
        }
    }

    _validatePeriodModify(){
        // Si hay 2 fechas seleccionadas
        if(this._flatpickr.selectedDates.length == 2){
            this._applyModifyPeriod.removeAttribute('disabled');
        }else{
            this._applyModifyPeriod.setAttribute('disabled',true);
        }
    }

    _onClickApplyModify(e){
        e.preventDefault();
        let payloadObj = {
            "from":this._flatpickr.selectedDates[0],
            "to":this._flatpickr.selectedDates[1]
        }
        if(this._daysSelected.length>=1){
            let daysBetween = getDaysBetweenDates( this._flatpickr.selectedDates[0], this._flatpickr.selectedDates[1], this._daysSelected );
            payloadObj.date_filters ={
                "weekdays":this._daysSelected,
                "specificdays":daysBetween
            };
        }
        this.main.dispatchEvent(new CustomEvent('MODIFY_PERIOD_SEND_RANGEDATE', {bubbles: false, detail: payloadObj}));
    }

    showModifyPeriod(billboardsArray = [], dateRange, modifyPeriod = false){
        /*set flag*/
        this.setModifyPeriod = modifyPeriod;
        this._isOpen = true;
        this._currentDateRange = {
            from: stringToDate(moment().add(1, 'days').format('YYYY-MM-DD').toString()),
            to: null
        };
        /*set title*/
        this._headerDateRange.innerHTML = `${dateToString(dateRange.from, 'M d Y')} to ${dateToString(dateRange.to, 'M d Y')}`;
        this._headerTitle.innerHTML = 'Modify period ('+ billboardsArray.length + (billboardsArray.length>1?' billboards':' billboard') +')';
        /*hide graph*/
        this._graphReferences.classList.add('d-none');
        this._recurrencesDays.classList.remove('d-none');
        if(this.getModifyPeriod){
            this._footer.classList.remove('d-none');
        }
        /*show modal*/
        this.show(this._currentDateRange);
        /*remove skeleton after show*/
        this.main.classList.remove('skeleton--show');
        /*init calendar*/
        this._initFlatpickr(this.getModifyPeriod);
    }

    showAvailability(billboardId, dateRange, exclusivity, brandId, brandCategoryId = null, weekdays = null, staticMinDaysBefore = true, packageId = null){
        this.show(dateRange);

        this._currentDateRange = dateRange;
        
        let fields = ['dates_available', 'days_available'];
        Billboards.getBillboardById(billboardId, fields, dateRange, exclusivity, brandId, brandCategoryId, weekdays, staticMinDaysBefore, packageId).then((data)=>{
            this._headerTitle.innerHTML = `${data.days_available} days available`;
            this._headerDateRange.innerHTML = `${dateToString(dateRange.from, 'M d Y')} to ${dateToString(dateRange.to, 'M d Y')}`;

            this._dates = [];
            data.dates_available.forEach((item)=>{
                this._dates[item.date] = {
                    price: item.price,
                    exclusivity: exclusivity // No pertenece al billboard sino a todos los billboards
                };
            })
                        
            this.main.classList.remove('skeleton--show');
            this._initFlatpickr();
        });
    }

    showDates(dates, dateRange, title = "days available"){
        this.show(dateRange);
        this.setDates(dates, dateRange, title);
    }

    setDates(dates, dateRange, title = "days available"){
        this._currentDateRange = dateRange;

        this._headerTitle.innerHTML = `${title}`;
        this._headerDateRange.innerHTML = `${dateToString(dateRange.from, 'M d Y')} to ${dateToString(dateRange.to, 'M d Y')}`;
        
        this._dates = [];
        dates.forEach((item)=>{
            if (!this._dates[item.date]) {
                this._dates[item.date] = [];
            }
            this._dates[item.date].push({
                price: item.price,
                exclusivity: item.exclusivity
            });
        });

        this._monthsCount = dateRange == null ? 2 : (dateRange.to.getFullYear()*12 + dateRange.to.getMonth()) - (dateRange.from.getFullYear()*12 + dateRange.from.getMonth()) + 1;

        if (!this._isMobileRes) {
            if(this._monthsCount <= 1){
                this.main.classList.add('billboard-calendar--single-month');
            }else{
                this.main.classList.remove('billboard-calendar--single-month');
            }
        } else {
            this.main.classList.add('billboard-calendar--single-month');
        }
                    
        this.main.classList.remove('skeleton--show');
        this._initFlatpickr();
    }
    
    _initFlatpickr(modifyPeriod = false){
        if(this._flatpickr != null){
            this._flatpickr.destroy();
        }

        this._holderFlatpickr.scrollTop = 0;

        let countMonths = (this._isMobileRes?1:2);
        let _this = this;
        
        /*if (this._currentDateRange.to) {
            if (this._isMobileRes) {
                countMonths = 1;
            } else {
                countMonths = ((this._currentDateRange.to.getFullYear() - this._currentDateRange.from.getFullYear()) * 12) + (this._currentDateRange.to.getMonth() - this._currentDateRange.from.getMonth()) + 1;
                countMonths = countMonths <= 1 ? 1 : 2;
            }
        }*/

        this._flatpickr = flatpickr(this.main, {
            monthSelectorType: 'static',
            yearSelectorType: 'static',
            minDate: this._currentDateRange.from,
            maxDate: this._currentDateRange.to,
            showMonths: countMonths,
            nextArrow: '<i class="material-icons">keyboard_arrow_right</i>',
            prevArrow: '<i class="material-icons">keyboard_arrow_left</i>',
            mode: (modifyPeriod?'range':'single'),
            dateFormat: 'Y-m-d',
            ariaDateFormat: 'Y-m-d',
            inline: this._isMobileRes,
            appendTo: this._holderFlatpickr,
            onChange: function (selectedDates, dateStr, instance) {
                if (selectedDates.length === 1 && _this.getRangeDuration!=0) {
                    _this._adjustEndDate(instance, selectedDates[0]);
                }
                if(modifyPeriod) {
                    _this._onFlatpickrChange();
                    _this._paintDaysSelected();
                    _this._checkDisabledDaysOfWeek();
                }
            },
            onMonthChange: ()=>{
                if (this._currentDateRange.to) {
                    this._checkArrows();
                }

                if(this.getModifyPeriod){
                    _this._paintDaysSelected();
                }
            },
            onDayCreate: (dObj, dStr, fp, dayElem) => {
                this._formatDay(dayElem, modifyPeriod);
                if(this.getRangeDuration!=0 && modifyPeriod){
                    dayElem.addEventListener("mouseover", function () {
                        _this._highlightRange(dayElem.dateObj, fp);
                    });
                }
                if(!modifyPeriod){
                    dayElem.addEventListener('mousedown', (e)=>{
                        if(!isMobileDevice()){
                            e.preventDefault();
                            e.stopPropagation();
                        }                        
                    })

                    dayElem.addEventListener('touchend', ()=>{
                        setTimeout(()=>{
                            if(dayElem.classList.contains('selected')){
                                this._flatpickr.clear();
                            }
                        }, 100)
                        
                    })
                }
            },
            onOpen: () => {
                this._isOpen = true;
            },
            onClose: (selectedDates, dateStr, instance) => {
                this._isOpen = false;

                document.body.classList.remove('billboard-calendar--open');
            },
            onReady: (selectedDates, dateStr, instance) => {
                setTimeout(()=>{
                    if (this._currentDateRange.to) {
                        this._checkArrows();
                    }
                    if(this.getModifyPeriod){
                        this._addRangeButtons(instance);
                        this._paintDaysSelected();
                        this._checkDisabledDaysOfWeek();
                    }
                    if(this.getRangeDuration!=0 && modifyPeriod){
                        instance.calendarContainer.addEventListener("mouseleave", function () {
                            _this._resetHighlight(instance);
                        });
                    }
                    this._flatpickr.open();
                }, 0)
            },
            closeOnSelect: false
        });
    }

    _addRangeButtons(fp) {
        let _this = this;
        this._footer.querySelectorAll(".range-button").forEach(function (button) {
            if(_this.getRangeDuration==button.dataset.days){
                button.classList.add("active");
            }
            button.addEventListener("click", function () {
                _this.setRangeDuration = button.dataset.days;
                _this._resetActiveButton();
                button.classList.add("active");

                _this._flatpickr.redraw();
                if (fp.selectedDates.length > 1) {
                    _this._adjustEndDate(fp, fp.selectedDates[0]); 
                }
                _this._paintDaysSelected();
            });
        });
        
    }


    _adjustEndDate(fp, startDate) {
        
        const endDate = new Date(startDate);
        endDate.setDate(startDate.getDate() + Math.max(14, this._rangeDuration) - 1); // Calcula la nueva fecha final
        
        const currentMonth = fp.currentMonth;
        const currentYear = fp.currentYear;

        fp.setDate([startDate, endDate], true); // Establece el nuevo rango de fechas
        this._resetHighlight(fp);
        fp.currentYear = currentYear;
        fp.currentMonth = currentMonth;
        fp.redraw();
    }

    _highlightRange(date, fp) {
        this._resetHighlight(fp);
        let _this = this;
        if(_this.getModifyPeriod){
            fp.calendarContainer.querySelectorAll(".flatpickr-day").forEach(function (dayElem) {
                if (dayElem.dateObj) {
                    const diff = (dayElem.dateObj - date) / (1000 * 60 * 60 * 24);
                    if (diff >= 0 && diff < _this._rangeDuration) {
                        dayElem.classList.add("inRangeWeek"); 
                    }
                }
            });
        }
    }

    _resetHighlight(fp) {
        fp.calendarContainer.querySelectorAll(".flatpickr-day").forEach(function (dayElem) {
            dayElem.classList.remove("inRangeWeek"); 
        });
    }

    _resetActiveButton() {
        this._footer.querySelectorAll(".range-button").forEach(function (button) {
            button.classList.remove("active"); 
        });
    }

    hide(){
        this._isOpen = false;
        if(this.getModifyPeriod){
            this._graphReferences.classList.remove('d-none');
            this._recurrencesDays.classList.add('d-none');
            this._footer.classList.add('d-none');
            this._resetSelectedDaysOfWeek();
            this.setModifyPeriod = false;
        }
        this._flatpickr.close();
    }

    _onClickCloseBtn(e){
        e.preventDefault();
        this.hide();
    }

    _onClickDaysOfWeek(e){
        let value = e.target.dataset.value,
        indexValue = this._daysSelected.indexOf(value);

        if(indexValue == -1){
            this._daysSelected.push(value);
            e.target.classList.add("active");
        }else{
            this._daysSelected.splice(indexValue, 1);
            e.target.classList.remove("active");
        }
        this._paintDaysSelected();
    }

    _paintDaysSelected(e){
        let allDaysSelectedWeek = this._flatpickr.daysContainer.querySelectorAll(".selected--week");
        /*busco los dia del mes dentro del rango filtrando por el dia seleccioando (tue, mon, sun, etc..)*/
        let daysBetween = getDaysBetweenDates( this._flatpickr.selectedDates[0], this._flatpickr.selectedDates[1], this._daysSelected );
        /*recorro los dias del rango para resetear todas las clases*/
        allDaysSelectedWeek.forEach((day)=>{
            //les borro la class selected
            day.classList.remove('selected--week');
            day.classList.add('inRange');
        });
        /*si hay al menos 1 dia seleccionado*/
        if(this._daysSelected.length>=1){
            /*verifico si hay dias en el array*/
            if(daysBetween.length>=1){
                /*recorro los dias*/
                daysBetween.forEach((day)=>{
                    let nday = new Date(day);
                    /*selecciono los dias filtrados*/
                    let daysCalendarHtml = this._flatpickr.daysContainer.querySelectorAll("span[aria-label='"+dateToString(nday)+"']");
                    /*agrego y borro class*/
                    daysCalendarHtml.forEach((day)=>{
                        day.classList.add('selected--week');
                        day.classList.remove('inRange');
                    });
                });
            }
        }
    }

    _resetSelectedDaysOfWeek(){
        for (const day of this._recurrencesDaysList.querySelectorAll('li')) {
            day.classList.remove("active");
        }
        this._daysSelected = [];
    }


    _onFlatpickrChange(e){
        this._validatePeriodModify();
        //this._resetSelectedDaysOfWeek();
        this._checkDisabledDaysOfWeek();
    }

    _checkDisabledDaysOfWeek(){
        for (const day of this._recurrencesDaysList.querySelectorAll('li')) {
            let daysBetween = getDaysBetweenDates( this._flatpickr.selectedDates[0], this._flatpickr.selectedDates[1], [day.dataset.value] );
            if(daysBetween.length<=0){
                day.classList.add('disabled');
            }else{
                day.classList.remove('disabled');
            }
        }
    }

    _formatDay(dayElem, modifyPeriod){
        let dateStr = dateToString(dayElem.dateObj);
        let num = dayElem.textContent;
        if(dayElem.classList.contains('flatpickr-disabled') || modifyPeriod){
            dayElem.innerHTML = /*html*/`<span class="flatpickr-day-wrapper">
                                        <span class="flatpickr-day-number">${num}</span>
                                        </span>`;
        } else if(this._dates[dateStr] && typeof this._dates[dateStr].price !== 'undefined'){
            dayElem.classList.add('flatpickr-day--available');

            if (this._dates[dateStr].exclusivity) {
                dayElem.classList.add('flatpickr-day--exclusive');
            }

            dayElem.innerHTML = /*html*/`<span class="flatpickr-day-wrapper">
                                        <span class="flatpickr-day-number">${num}</span>
                                        <span class="billboard-calendar__tooltip-box">
                                            <div class="billboard-calendar__price-text">Price</div>
                                            <div class="billboard-calendar__price-num">${formatPrice(this._dates[dateStr].price)}</div>
                                        </span>
                                    </span>`;
        } else if(this._dates[dateStr] && this._dates[dateStr].filter((date) => typeof date.price !== 'undefined').length > 0) {
            dayElem.classList.add('flatpickr-day--available');

            if (this._dates[dateStr].filter((date) => date.exclusivity).length > 0) {
                dayElem.classList.add('flatpickr-day--exclusive');
            }

            const prices = this._dates[dateStr].map((date) => formatPriceWithDecimals(date.price));
            const price = prices.join(', ');

            dayElem.innerHTML = /*html*/`<span class="flatpickr-day-wrapper">
                                        <span class="flatpickr-day-number">${num}</span>
                                        <span class="billboard-calendar__tooltip-box ${prices.length > 1 ? 'billboard-calendar__tooltip-box--size-1' : ''}">
                                            <div class="billboard-calendar__price-text">Price</div>
                                            <div class="billboard-calendar__price-num">${price}</div>
                                        </span>
                                    </span>`;
        }else{
            dayElem.innerHTML = /*html*/`<span class="flatpickr-day-wrapper  flatpickr-day-wrapper--not-available">
                                        <span class="flatpickr-day-number">${num}</span>
                                            <span class="billboard-calendar__tooltip-box">Not available</span>
                                        </span>`;
        }
    }

    _onWindowResize(e){
        if(this._isOpen){
            if(!this._isMobileRes && isMobileRes()){
                this._isMobileRes = true;
                this._initFlatpickr(this.getModifyPeriod); 
            }
    
            if(this._isMobileRes && !isMobileRes()){
                this._isMobileRes = false;
                this._initFlatpickr(this.getModifyPeriod);
            }
        }
    }

    _checkArrows(){
        if(this._monthsCount > 1){
            let currentDateRangeMonthTo = this._currentDateRange.to.getMonth();
            let currentDateRangeYearTo = this._currentDateRange.to.getFullYear();
            
            // In desktop are two months visible at the same time
            if (!this._isMobileRes) {
                currentDateRangeMonthTo-=1;
            }

            // Check Year
            if(this._flatpickr.currentYear < currentDateRangeYearTo){
                return;
            }

            // Check month
            if(this._flatpickr.currentMonth == currentDateRangeMonthTo){
                this.main.querySelector('.flatpickr-next-month').classList.add('flatpickr-disabled');
            }else{
                this.main.querySelector('.flatpickr-next-month').classList.remove('flatpickr-disabled');
            }
        }
    }

    addEventListener(event, callback){
        this.main.addEventListener(event, callback);
    }
}


const BillboardCalendar = new BillboardCalendarClass();
Object.seal(BillboardCalendar)

export default BillboardCalendar;
